import script from "./ReleaseCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ReleaseCard.vue?vue&type=script&setup=true&lang=js"

import "./ReleaseCard.vue?vue&type=style&index=0&id=20447f58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20447f58"]])

export default __exports__